module.exports = __webpack_public_path__ + "static/media/Item_Weapon_QBU88_C.ec92d4fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_QBU88_C.png
// module id = 412
// module chunks = 0